import { type PlayOptions } from '../audio/AudioManager';
import { Behavior } from '../entities/Behavior';

/**
 * Plays a sound when its entity is clicked.
 *
 * Configured with an asset key and nothing else, which is what keeps it a piece of engine furniture
 * rather than a callback in disguise: a string survives serialization, an editor round trip and a
 * content file, and a function does not.
 *
 * Pairs with the `Clickable` component. A key that was never loaded plays nothing rather than throwing,
 * so a missing sound never ends a play session.
 */
export class PlaySoundOnClick extends Behavior {
  readonly #audioKey: string;
  readonly #options: PlayOptions;

  constructor(audioKey: string, options: PlayOptions = {}) {
    super();
    this.#audioKey = audioKey;
    this.#options = options;
  }

  /** Subscribes to clicks on this entity only, for as long as it stays attached. */
  override onAttach(): void {
    this.subscribeForEntity('entityClicked', () => {
      this.context.audio.play(this.#audioKey, this.#options);
    });
  }
}
